import useAccountingApi from "views/Settings/Accounting/hooks/useAccountingApi";
import ExportForm from "../../TransferToAccounts/components/ExportForm";
import ExportCard from "../../TransferToAccounts/components/ExportCard";
import useCoreStore from "views/hooks/useCoreStore";
import { Col, FormInstance } from "antd";
import { useEffect } from "react";

interface AccountingSettingsFormProps {
  form: FormInstance;
}

export default function AccountingSettingsForm({
  form,
}: AccountingSettingsFormProps): React.ReactElement {
  const companySelected = useCoreStore(state => state.companySelected);
  const companyData = useCoreStore(state => state.companyData);
  const hasNotAccountingFirm = companyData?.hasNotAccountingFirm;
  const { getCompanyPlatform, platformData } = useAccountingApi({ form });

  useEffect(() => {
    if (companySelected) {
      getCompanyPlatform({
        variables: {
          id: companySelected?.id,
        },
      });
    }
  }, [companySelected]);

  return (
    <>
      {hasNotAccountingFirm ? (
        <Col span={24}>
          <ExportForm form={form} />
        </Col>
      ) : (
        <Col span={24}>
          <ExportCard platformData={platformData} />
        </Col>
      )}
    </>
  );
}
